import { render, staticRenderFns } from "./cxLazyImg.vue?vue&type=template&id=0024838a"
import script from "./cxLazyImg.vue?vue&type=script&lang=js"
export * from "./cxLazyImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports